import { applyPitchMiddleware } from "@/app/(application)/(normal)/create/components/input/applyPitchMiddleware";
import { PitchMiddleware } from "@/app/(application)/(normal)/create/components/input/types";
import { frequencyToSemitones } from "@/utils/frequencyToSemitones";
import { semitonesToFrequency } from "@/utils/semitonesToFrequency";

export const pitchGetterFollowup =
  (...middleware: PitchMiddleware[]) =>
  async (pitchesFetchedFromBackend: Promise<number[]>) => {
    const resolvedPitches = await pitchesFetchedFromBackend;
    const originalPitches = resolvedPitches
      .slice(300, -300)
      .map((i) => (i === 0 ? 0 : frequencyToSemitones(i)));
    return [
      ...resolvedPitches.slice(0, 300),
      ...applyPitchMiddleware(...middleware)(originalPitches).map((i) =>
        i === 0 ? 0 : semitonesToFrequency(i)
      ),
      ...resolvedPitches.slice(-300),
    ];
  };
